



















































































import {
  Vue,
  Component,
  PropSync,
  Watch,
  Ref,
  Prop,
  Emit
} from 'vue-property-decorator'
import ReadAndAccept from '@/modules/tournament/components/ReadAndAccept'
import InGameNameRegistration from '@/modules/tournament/components/InGameNameRegistration'
import TournamentRegistration from '@/modules/tournament/components/TournamentActionDialog/TournamentRegistration'
import EnterInvitationCode from '@/modules/tournament/components/EnterInvitationCode'
import TeamRegistration from '@/modules/tournament/components/TournamentActionDialog/TeamRegistration'
import TeamRegistrationComplete from '@/modules/tournament/components/TournamentActionDialog/TeamRegistrationComplete'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import TeamRegistrationStatus from '@/modules/tournament/components/TournamentActionDialog/TeamRegistrationStatus/TeamRegistrationStatus.vue'
import ServerError from '@/utils/server_error'
import { TournamentAPI, TournamentEntity } from '@/api/tournament'
import { TokenAcceptPayload } from '@/modules/tournament/components/EnterInvitationCode/EnterInvitationCode.vue'
import TeamJoinDetailReview from '@/modules/tournament/components/TournamentActionDialog/TeamJoinDetailReview'
import { TournamentTeamEntity } from '@/api/tournamentTeam'
import TournamentCustomForm from '@/modules/tournament/components/TournamentCustomForm'
import { parseSchema } from '@/utils/customform_validation'

@Component({
  components: {
    TeamRegistrationStatus,
    EnterInvitationCode,
    ReadAndAccept,
    InGameNameRegistration,
    TournamentRegistration,
    TeamRegistration,
    TeamRegistrationComplete,
    TeamJoinDetailReview,
    TournamentCustomForm
  }
})
export default class LFGJoinActionDialog extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  step: number = 1
  steps: number[] = Array.from(new Array(5), (_, index) => index + 1)
  // custom form
  schema: any = {}
  formResponse: any = null

  @PropSync('isVisible', { type: Boolean, default: false })
  isModalVisible!: boolean

  @Prop({ type: Object, required: true }) readonly tournament!: TournamentEntity
  @Prop({ type: Object, required: true })
  readonly tournamentTeam!: TournamentTeamEntity

  @Ref('gameAccountRegistration')
  readonly gameAccountRegistration!: InGameNameRegistration

  @Ref('readAndAccept')
  readonly readAndAccept!: ReadAndAccept

  @Ref('enterInvitationCode')
  readonly enterInvitationCode!: EnterInvitationCode

  @Ref('teamRegistration')
  readonly teamRegistration!: TeamRegistration

  @Watch('isVisible')
  onDialogVisiblityChanged(visible: boolean) {
    if (visible) {
      if (this.hasJoinedTournament) {
        this.step = 5
      } else {
        this.step = 1
      }

      this.fetchTournamentCustomFormSchema()
    } else {
      setTimeout(() => {
        this.step = 1
        this.schema = {}
        this.formResponse = null
      }, 200)

      if (this.gameAccountRegistration) {
        this.gameAccountRegistration.reset()
      }

      if (this.readAndAccept) {
        this.readAndAccept.reset()
      }

      if (this.enterInvitationCode) {
        this.enterInvitationCode.reset()
      }

      if (this.teamRegistration) {
        this.teamRegistration.reset()
      }
    }
  }

  async fetchTournamentCustomFormSchema() {
    let response = await TournamentAPI.getTournamentCustomFormSchema(
      this.tournament!.tournamentId
    )
    if (response.data.payload) {
      try {
        this.schema = parseSchema(response.data.payload.schema)
      } catch {
        this.schema = {}
      }
    }
  }

  setIsVisible(isVisible: boolean = false) {
    this.isModalVisible = isVisible
  }

  onIGNCompleted() {
    this.step = this.schemaLength ? 2.5 : 3
  }

  async setFormResponse(value: any) {
    this.formResponse = value
    this.step = 3
  }

  get schemaLength() {
    return Object.keys(this.schema).length
  }

  get showBackButton() {
    if (this.hasJoinedTournament) {
      return
    }

    return this.step > 1 && this.step < 5
  }

  get hasJoinedTournament() {
    return !!this.tournamentModule.selectedTournamentTeam
  }

  back() {
    this.step--

    if (this.step < 1) {
      this.step = 1
    }

    if (this.enterInvitationCode) {
      this.enterInvitationCode.reset()
    }
  }

  async onJoinTournament() {
    this.step = 6
    await this.fetchJoinedTournamentTeam()
  }

  async fetchJoinedTournamentTeam() {
    try {
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.tournament!.tournamentId
      )
    } catch (err) {
      if (err instanceof ServerError) {
        if (err.getStatusCode() >= 400 && err.getStatusCode() < 500) {
          return
        }

        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
        console.error(err)
      }

      await this.$router.push('/')
    }
  }

  onJoinDetailReviewed() {
    this.confirmTeamJoin()
    this.step = 4
  }

  @Emit('confirmed')
  confirmTeamJoin() {
    return this.formResponse
  }

  // async submitTournamentFormResponse(token: string) {
  //   try {
  //     const response = await TournamentAPI.submitTournamentFormResponseWithToken(
  //       token,
  //       JSON.stringify(this.formResponse)
  //     )
  //   } catch (err) {
  //     if (err instanceof ServerError) {
  //       this.$toast.error(err.getMessage())
  //     } else {
  //       this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
  //       console.error(err)
  //     }
  //   }
  // }
}
